import React, { useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getApiUrl } from '../config/api';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const API_URL = getApiUrl('NEWSLETTER');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (data.success) {
        if (data.duplicate) {
          toast.info('You are already subscribed!');
        } else {
          toast.success('Successfully subscribed to newsletter!');
        }
        setEmail('');
      }
    } catch (error) {
      toast.error('❌ Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="newsletter-section">
      <Container>
        <div className="newsletter-card">
          <h2 className="newsletter-title">Join the Inner Circle</h2>
          <p className="newsletter-subtitle">Be the first to know when we launch</p>
          
          <Form onSubmit={handleSubmit} className="newsletter-form">
            <div className="newsletter-input-group">
              <Form.Control
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="newsletter-input"
                disabled={loading}
              />
              <Button type="submit" className="newsletter-btn" disabled={loading}>
                {loading ? 'Joining...' : 'Join here'}
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </section>
  );
};

export default Newsletter;